import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


import Homepage from './pages/Homepage';
import Termspage from './pages/Termspage';
import Privacypage from './pages/Privacypage';



// ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// GAHandler


const App = () => {


  return (
    <>
      <ScrollToTop />




      <Routes>
        <Route path="/" element={<Homepage />} />
  




        <Route path="/terms-and-conditions" element={<Termspage />} />
        <Route path="/privacy-policy" element={<Privacypage />} />




      </Routes>
    </>
  );
};

export default App;
